// 💾 src/pages/client/sections/components/Portfolio/SpotPanel.tsx
import { useEffect, useState } from "react"
import { CoinInfo } from "../../../../../types"
import "./style/SpotPanel.scss"

type Asset = {
  symbol: string
  balance: number
  price: number
  icon: string
  name: string
}

const MOCK_ASSETS: Asset[] = [
  {
    symbol: "BTC",
    balance: 0.0,
    price: 0,
    icon: "https://assets.coingecko.com/coins/images/1/large/bitcoin.png",
    name: "Bitcoin"
  },
]

const SpotPanel = () => {
  const [assets, setAssets] = useState<Asset[]>([])

  useEffect(() => {
    setAssets(MOCK_ASSETS) // In real: fetch from Firestore or API
  }, [])

  const totalValue = assets.reduce((sum, a) => sum + a.balance * a.price, 0)

  return (
    <div className="spot-panel">
      <div className="header">
        <h2>Spot Wallet</h2>
        <div className="total">Total Value: ${totalValue.toFixed(2)}</div>
      </div>

      <table className="spot-table">
        <thead>
          <tr>
            <th>Asset</th>
            <th>Balance</th>
            <th>Price</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          {assets.map(asset => (
            <tr key={asset.symbol}>
              <td className="asset-cell">
                <img src={asset.icon} alt={asset.symbol} />
                <div>
                  <div className="symbol">{asset.symbol}</div>
                  <div className="name">{asset.name}</div>
                </div>
              </td>
              <td>{asset.balance}</td>
              <td>${asset.price.toFixed(2)}</td>
              <td>${(asset.balance * asset.price).toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default SpotPanel
